export default "__VITE_ASSET__7f8b2a27__"